import lazyLoad from '@utils/lazyLoad'

const wxRedEnvelopeRoutes = [
  {
    path: '/wxRedEnvelope/detail',
    exact: true,
    component: lazyLoad(() => import('@views/WxRedEnvelope/index'))
  }
]

export default wxRedEnvelopeRoutes
